import type { GadgetDirectoryResourceData } from '@atlassian/jira-dashboard-common/src/types.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (): Promise<GadgetDirectoryResourceData | null> =>
	performGetRequest('/rest/config/1.0/directoryitems.json');
